const MakeYouFeelMyLove = [
	'[Verse 1]',
	'When the rain is blowing in your face',
	'And the whole world is on your case',
	'I could offer you a warm embrace',
	'To make you feel my love',
	'',
	'[Verse 2]',
	'When evening shadows and the stars appear',
	'And there is no one there to dry your tears',
	'I could hold you for a million years',
	'To make you feel my love',
	'',
	'[Bridge 1]',
	"I know you haven't made your mind up yet",
	'But I would never do you wrong',
	"I've known it from the moment that we met",
	'No doubt in my mind where you belong',
	'',
	'[Verse 3]',
	"I'd go hungry, I'd go black and blue",
	"I'd go crawling down the avenue",
	"No, there's nothing that I wouldn't do",
	'To make you feel my love',
	'',
	'[Bridge 2]',
	"The storms are raging on the rollin' sea",
	'And on the highway of regret',
	'The winds of change are blowing wild and free',
	"You ain't seen nothing like me yet",
	'',
	'[Outro]',
	'I could make you happy, make your dreams come true',
	"Nothing that I wouldn't do",
	'Go to the ends of the earth for you',
	'To make you feel my love',
	'To make you feel my love',
];

export default MakeYouFeelMyLove;
